import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider, useDataProvider, Result, DataContext, callApi, Loader } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import DataTable from  "@cloudpremise/portal_core/src/themes/mui/examples/Tables/DataTable";
import ContactModal from "../components/ContactModal";
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";

// @mui material components
import Link from "@mui/material/Link";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Card from "@mui/material/Card";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import EditIcon from "@mui/icons-material/Edit";
import PreviewIcon from "@mui/icons-material/Preview";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import { Contact } from "../types";


const Contacts = (props) => {
    const dataProvider = useContext(DataContext);
    const defaultState = {
        page: 1,
        callApi: true,
        loading: false,
        loadingMore: false,
        response: null,
        viewMore: false,
        RF_LIMIT: 20,
        RF_OFFSET: 0,
        showLoadMore: false,
        cancelToken: null,
        RF_ORDER_BY: null,
        errorMessage: null,
        saving: false,
        sortColumn: 'Name',
		sortColumnDirection: {
			Name: 'asc',
		},
		selection: [],
        searchText: "",
        itemModal: false,
        items: null,
        dataTableRef: React.createRef(),
        row: null
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const [ authorized, authType ] = useAuthProvider();
    const navigate = useNavigate();

    const record: Contact = {
        sObjectTypeName: "Contact",
        url: "/v1/sobject",
        params: {
            "RF_LIMIT": state.RF_LIMIT,
            "RF_OFFSET": state.RF_OFFSET,
        }
    }
    const [loading, data, adapterState, setAdapterState] = useDataProvider(record, {
        
    }, false, (data: Result) => {
        let rows = [];
        if(data && Array.isArray(data?.result)){
            rows = data.result;
        }
        let errorMessage = null;
        if(data.hasOwnProperty("error") && data.error !== null){
            errorMessage = data.error;
        }
        setState({
            items: rows,
            errorMessage: errorMessage
        });
    });

    React.useEffect(() => {
        if(authorized && (authType !== "salesforce")){
            return navigate("/auth-not-supported", { replace: true });
        }

        const onScroll = () => {
            const scroll = window.scrollY;
            const height = document.body.scrollHeight - (window.innerHeight + 200);
            // console.log("Scroll = "+scroll+" Height = "+height);
            if(scroll >= height){
                handleLoadMore();
            }
        };

        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    });

    function onRowClick(event, row){
        event.preventDefault();
        setState({
            editModal: true,
            row: row
        });
    }

    function getTableData(){
        let rows = [];
        if(state.items && Array.isArray(state.items)){
            rows = state.items;
        }
        const tableData = {
            columns: [
                {
                    Header: "Id",
                    accessor: "Id",
                    Cell: (instance) => {
                        return (
                            <Link color="info" href="/" onClick={(event) => onRowClick(event, instance.row.original)}>
                                {instance.value}
                            </Link>
                        )
                    },
                },
                {
                    Header: "Name",
                    accessor: "Name",
                },
                {
                    Header: "AccountId",
                    accessor: "AccountId",
                },
                {
                    Header: "Email",
                    accessor: "Email",
                },
                {
                    Header: "Phone",
                    accessor: "Phone",
                },
                { Header: "Actions", accessor: "actions", width: "12%" },
            ],
            rows: rows
        };
        const items = [];
        rows.map((row, key) => {
            const itemObj = {
                ...row,
                key: (key + 1),
                id: row.Id,
            };
            items.push({
                ...itemObj,
                onClick: () => { handleRowAction(itemObj, {value: "edit"}) },
                actions: (
                    <>
                        <MDButton
                            variant="gradient"
                            color="info"
                            onClick={() => handleRowAction(row, {value: "edit"})}
                            iconOnly
                            style={{marginRight: "5px"}}
                            size="small"
                        >
                            {(row.isClosed ? <PreviewIcon /> : <EditIcon />)}
                        </MDButton>
                        <MDButton
                            variant="gradient"
                            color="error"
                            onClick={() => handleRowAction(row, {value: "delete"})}
                            iconOnly
                            size="small"
                        >
                            <CloseIcon />
                        </MDButton>
                    </>
                )
            });
            return null;
        });
        tableData.rows = items;
        return tableData;
    }
    function handleRowAction(item, action){
        let newState = {
            [action.value+"Modal"]: true
        };
        if(item !== null){
            newState['row'] = item;
        }
        setState(newState);      
	}
    function handleRowClick(event, item){
        setState({
            row: item
        });
	}
    function handleLoadMore(){
        if(!adapterState.hasMore || state.items === null || adapterState.callApi || adapterState.loading){
            return;
        }
        setAdapterState({
            loading: false,
            callApi: true,
            viewMore: true,
            RF_OFFSET: adapterState.RF_OFFSET + state.RF_LIMIT
        });
    }
    function getSortColumnName(){
        const columns = {
            key: "Number",
            Id: "Id",
            Name: "Name",
            Email: "Email",
            ContactId: "ContactId",
            Phone: "Phone"
        };
        return columns;
    }
    function onContactModal(status = true){
        setState({
            editModal: false,
            itemModal: status
        });
    }
    function onContactModalSuccess(data){
        if(state.editModal){
            state.items.map((contact, key) => {
                if(contact.Id === data.Id){
                    state.items[key] = data;
                }
                return null;
            });
        }else{
            if(state.items === null){
                state.items = [];
            }
            state.items.push(data);
        }
        setState({
            editModal: false,
            itemModal: false,
            items: state.items,
            errorMessage: null
        });
    }
    function onDeleteModalSuccess(){
        const { row } = state;
        const deleteRecord: Contact = {
            sObjectTypeName: "Contact",
            url: "/v1/sobject",
            method: 'DELETE',
            params: {
                sobjecttypename: "Contact",
                Id: row.Id
            },
            headers: {},
            data: {}
        }
        callApi(dataProvider, deleteRecord).then(data => {
            state.items.map((item, key) => {
                if(item.Id === row.Id){
                    state.items.splice(key, 1);
                }
                return null;
            });
            setState({
                editModal: false,
                itemModal: false,
                deleteModal: false,
                items: state.items,
            });  
        }).catch(err => {
            setState({
                saving: false,
                errorMessage: err.message
            });
        });

        setState({
            saving: true,
            errorMessage: null
        });
    }
    function onConfirmationModal(status = true){
        setState({
            itemModal: false,
            deleteModal: status,
            errorMessage: null
        });
    }
    const tableData = getTableData();

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={2}>
                <Card>
                    <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" p={2}>
                        <h3>Contacts sObject API Demo (MP)</h3>
                        <MDButton
                            variant="gradient"
                            color="info"
                            onClick={() => onContactModal()}
                        >
                            New Contact
                        </MDButton>
                    </MDBox>
                    {
                        loading ?
                            <Loader p={2} color="info" />
                        :
                            state.errorMessage !== null ?
                                <Stack p={2}>
                                    <Alert severity="error">{state.errorMessage}</Alert>
                                </Stack>
                            :
                                <DataTable
                                    table={getTableData()}
                                    canSearch={false}
                                    isSorted={true}
                                    entriesPerPage={false}
                                    rowsCount={tableData.rows.length}
                                    manualPagination
                                    loading={adapterState.viewMore}
                                />
                    }
                </Card>
            </MDBox>
            {
                state.itemModal ?
                    <ContactModal
                        open={state.itemModal}
                        onCancel={() => onContactModal(false)}
                        onSuccess={onContactModalSuccess}
                    />
                :
                null
            }
            {
                state.editModal ?
                    <ContactModal
                        open={state.editModal}
                        item={state.row}
                        onCancel={() => onContactModal(false)}
                        onSuccess={onContactModalSuccess}
                        onDelete={onDeleteModalSuccess}
                        onObjectAction={(action) => handleRowAction(state.row, {value: action})}
                    />
                :
                null
            }
            {
                state.deleteModal ?
                    <Confirmation
                        open={state.deleteModal}
                        item={state.row}
                        onCancel={() => onConfirmationModal(false)}
                        onSuccess={onDeleteModalSuccess}
                        message={"Are you sure you want to delete?"}
                        saving={state.saving}
                        errorMessage={state.errorMessage}
                    />
                :
                null
            }
        </DashboardLayout>
    )
}

export default Contacts;